module.exports = {
    projectUrl: "",
    projectName: "teqbahn",
    apiURL:""
}
